const newsList = document.querySelector('.news-list');

if (newsList) {
  const dropdownInputs = newsList.querySelectorAll('.news-list .dropdown__list-item input');

  const axiosGetNewsList = async (parent, slug, pageNumber) => {
    const action = parent.querySelector('[data-action]').value;
    const initialCategoryData = parent.querySelector('[data-initial]').value;
    const firstBigCardNews = parent.querySelector('[data-big-card]')?.value;
    const newsList = parent.querySelector('.news-list__list');
    const noResultElem = parent.querySelector('.news-list__not-found');
    const newsListFooter = parent.querySelector('.news-list__footer');

    parent.scrollIntoView();

    const formDataInput = {
      action,
      slug,
      initialCategoryData,
      firstBigCardNews,
      pageNumber,
      newsCategory: slug,
      newsTag: new URLSearchParams(window.location.search).get('newsTag'),
      nonce: await getNonceForAction(action),
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      newsList.innerHTML = '';

      if (newsList && data.data.html_list) {
        newsList.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      if (newsListFooter && data.data.html_pagination) {
        newsListFooter.innerHTML = data.data.html_pagination;
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['newsTag', 'newsCategory', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }
  };

  // Dropdown click
  dropdownInputs.forEach((input) => {
    input.addEventListener('change', (ev) => {
      ev.preventDefault();
      const parent = ev.target.closest('.news-list');
      const dataSlug = ev.target.getAttribute('data-slug');

      axiosGetNewsList(parent, dataSlug, 1);
    });
  });

  // Pagination
  attachEvent('.news-list .pagination .pagination__number', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.news-list');
    const checkedInput = parent.querySelector('.dropdown__list-item input:checked');
    const dataSlug = checkedInput?.getAttribute('data-slug');
    const pageNumber = ev.target.dataset.page;
    axiosGetNewsList(parent, dataSlug, pageNumber);
  });
}
